import { utils as ethersUtils } from "ethers";
import { recoverTypedDataAddress } from "viem";

export type TypedDataDefinition = Record<string, readonly { name: string; type: string }[]>;

export type HyperliquidSignatureComponents = {
  r: `0x${string}`;
  s: `0x${string}`;
  v: number;
};

export const splitSignature = (signature: `0x${string}`): HyperliquidSignatureComponents => {
  const { r, s, v } = ethersUtils.splitSignature(signature);
  return {
    r: r as `0x${string}`,
    s: s as `0x${string}`,
    v,
  };
};

export const joinSignature = ({ r, s, v }: HyperliquidSignatureComponents): `0x${string}` =>
  ethersUtils.joinSignature({ r, s, v }) as `0x${string}`;

export const assertSignatureRoundTrip = (original: `0x${string}`, components: HyperliquidSignatureComponents) => {
  const reconstructed = joinSignature(components);

  if (reconstructed.toLowerCase() !== original.toLowerCase()) {
    throw new Error("Hyperliquid signature components mismatch");
  }
};

export const assertRecoveredAddressMatches = async ({
  signature,
  domain,
  types,
  primaryType,
  message,
  expectedAddress,
}: {
  signature: `0x${string}`;
  domain: Record<string, unknown>;
  types: TypedDataDefinition;
  primaryType: string;
  message: Record<string, unknown>;
  expectedAddress: string;
}) => {
  const recoveredAddress = await recoverTypedDataAddress({
    signature,
    domain,
    types,
    primaryType,
    message,
  });

  if (recoveredAddress.toLowerCase() !== expectedAddress.toLowerCase()) {
    throw new Error(
      `Signature recovered address does not match connected wallet. Recovered: ${recoveredAddress}, Expected: ${expectedAddress}`,
    );
  }
};
